<template>
  <tr>
    <th>
      메시지
      <span v-if="required" class="required">*</span>
      <div class="count">
        (
        <span class="current">{{ boardContent_local.length }}</span>
        /{{ maxLength }})
      </div>
    </th>
    <td>
      <div v-if="useSample" class="btn_area type_fr" style="margin-bottom: 10px">
        <button type="button" class="reverse" @click="openRepeatContentSample({onSelected: onSampleSelected})">* 예문 보기</button>
      </div>
      <textarea
        class="inp_ta"
        :maxlength="maxLength"
        style="height: 173px"
        :placeholder="`* 사용자가 &quot;새소식 알려줘&quot; 라고 발화했을 때 들려줄 메시지를 ${maxLength}자 이내로 입력해 주세요.\n   문장 마지막은 꼭 문장부호 마침표(.), 쉼표(,) 또는 물음표(?)를 써주세요.`"
        v-model="boardContent_local"
        ref="input"
      ></textarea>
      <p class="caution">
        <TTSPlayer ref="ttsPlayer" :textContent="boardContent_local" @validationFailed="$refs.input.focus()" @click="onClickTTS" />
        <span class="ico">*</span> 등록 내용이 스피커에서 알아듣기 쉽게 나오는지 [TTS 미리듣기]로 확인 해 주세요. <br />어색한 부분은
        띄어쓰기와 마침표, 쉼표를 적절히 사용해주시면 보정됩니다.
      </p>
    </td>
  </tr>
</template>

<script>
import TTSPlayer from './ContentInput.tts.player';
import newsMixin from '$views/News/_mixin';

export default {
  components: {TTSPlayer},
  mixins: [newsMixin],
  props: {
    boardContent: String,
    required: Boolean,
    useSample: Boolean,
    maxLength: {
      type: Number,
      default: 500,
    },
  },
  data() {
    return {
      ttsCheckedText: this.boardContent,
      boardContent_local: this.boardContent,
    };
  },
  watch: {
    boardContent_local(val) {
      this.$emit('update:boardContent', val);
    },
  },
  methods: {
    onClickTTS() {
      if (!this.validateContent()) return;
      this.$refs.ttsPlayer.loadAndPlay(this.boardContent_local);
      this.ttsCheckedText = this.boardContent_local;
    },
    validateContent() {
      // 내용
      if (this.required && !this.boardContent) {
        alert('메시지 내용을 입력해 주세요.');
        this.$refs.input.focus();
        return false;
      }

      // 특수문자
      const contentRegExp = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9|\.\,\ \?\!\"\'\~\n\r]/gi;
      if (contentRegExp.test(this.boardContent)) {
        const msg = '쉼표, 마침표 등의 문장부호 외에 특수문자는 쓸 수 없습니다.\n해당 특수문자를 지우시겠습니까?';
        confirm(msg).then(() => {
          this.boardContent_local = this.boardContent_local.replace(contentRegExp, '');
        });
        this.$refs.input.focus();
        return false;
      }
      return true;
    },
    validate() {
      if (!this.validateContent()) return false;
      // tts 체크했는지 확인해야함.
      if (this.ttsCheckedText != this.boardContent_local) {
        alert('TTS 미리듣기를 눌러서\n스피커 음성을 미리 확인해 주세요.');
        this.$refs.ttsPlayer.focus();
        return false;
      }
      return true;
    },
    onSampleSelected(content) {
      this.boardContent_local = content;
    },
  },
};
</script>

<style></style>
